const teTranslations = {
  "errors.duplicateProfileMobile":
    "ఈ మొబైల్ నంబర్‌తో ఇప్పటికే ఒక ప్రొఫైల్ ఉంది. ఇదే మొబైల్ నంబర్‌తో ఈ బ్యూరోలో గానీ, మరే ఇతర బ్యూరోలో గానీ మళ్లీ నమోదు చేసుకోలేరు.",
  "navbar.home": "హోమ్",
  "navbar.menu.search": "వెతకండి",
  "navbar.myProfiles": "నా ప్రొఫైల్స్",
  "navbar.profileMenu.myProfile": "నా ప్రొఫైల్",
  "navbar.editPrivacy": "కార్యాలయ గోప్యతను సవరించు",
  "navbar.terms": "నిబంధనలు & షరతులు",
  "navbar.logout": "లాగ్ అవుట్",
  "navbar.language": "భాష",
  "navbar.language.english": "En",
  "navbar.language.telugu": "తె",
  "navbar.notificationsTitle": "నోటిఫికేషన్లు",
  "navbar.notificationsEmpty": "క్రొత్త నోటిఫికేషన్లు లేవు",
  "navbar.notificationsViewAll": "అన్ని నోటిఫికేషన్లు చూడండి",
  "navbar.notificationsNewInterest": "బ్యూరో ఐడి నుంచి కొత్త ఆసక్తి వచ్చింది: ",
  "navbar.idLabel": "ఐడి:",
  "navbar.mobile.maleProfiles": "నిష్క్రియ పురుష ప్రొఫైల్స్",
  "navbar.mobile.femaleProfiles": "నిష్క్రియ మహిళా ప్రొఫైల్స్",
  "navbar.mobile.otherProfiles": "ఇతర ప్రొఫైల్స్",
  "navbar.mobile.notifications": "నా నోటిఫికేషన్లు",
  "navbar.mobile.terms": "నిబంధనలు & షరతులు",
  "navbar.mobile.community": "సామాజిక మార్గదర్శకాలు & నిబంధనలు",
  "navbar.mobile.editPassword": "పాస్‌వర్డ్ సవరించు",
  "navbar.mobile.editPrivacy": "కార్యాలయ గోప్యతను సవరించు",
  "navbar.mobile.editWebsite": "వెబ్‌సైట్ సవరించు",
  "navbar.mobile.howToUse": "ఎలా ఉపయోగించాలి",
  "navbar.mobile.updatePhoto": "ప్రొఫైల్ ఫొటోను అప్డేట్ చేయండి",
  "navbar.mobile.logout": "లాగ్ అవుట్",
  "navbar.mobile.language": "భాష",
  "dashboard.noProfiles": "ఈ విభాగంలో ప్రొఫైల్స్ లభ్యంకాలేదు.",
  "dashboard.sections.yourProfiles": "మీ స్వంత ప్రొఫైల్స్",
  "dashboard.sections.pendingProfiles": "అపూర్ణ ప్రొఫైల్స్",
  "dashboard.sections.freeProfiles": "ఫ్రీ ప్రొఫైల్స్",
  "dashboard.sections.paidProfiles": "పెయిడ్ ప్రొఫైల్స్",
  "dashboard.sections.redzoneProfiles": "రెడ్ జోన్ ప్రొఫైల్స్",
  "dashboard.sections.callBackProfiles": "కాల్ బ్యాక్ ప్రొఫైల్స్",
  "dashboard.sections.notRespondingProfiles":
    "స్పందించని ప్రొఫైల్స్",
  "dashboard.sections.otherMediatorProfiles": "ఇతర మిడియేటర్ చే జోడించిన ప్రొఫైల్స్",
  "dashboard.sections.otherProfiles": "ఇతర బ్యూరో ప్రొఫైల్స్",
  "dashboard.sections.shortlisted": "ఎంపిక చేసిన ప్రొఫైల్స్",
  "dashboard.sections.male": "పురుషులు",
  "dashboard.sections.female": "మహిళలు",
  "dashboard.count.default": "ప్రొఫైల్స్",
  "dashboard.count.pending": "పెండింగ్",
  "dashboard.count.shortlisted": "ఎంపిక",
  "dashboard.buttons.viewAll": "అన్నీ చూడండి",
  "dashboard.buttons.viewAllMale": "అన్ని నిష్క్రియ పురుష ప్రొఫైల్స్ చూడండి",
  "dashboard.buttons.viewAllFemale": "అన్ని నిష్క్రియ మహిళా ప్రొఫైల్స్ చూడండి",
  "dashboard.buttons.reviewPendingMale":
    "పెండింగ్ పురుష ప్రొఫైల్స్‌ను సమీక్షించండి",
  "dashboard.buttons.reviewPendingFemale":
    "పెండింగ్ మహిళా ప్రొఫైల్స్‌ను సమీక్షించండి",
  "dashboard.buttons.exploreOtherMale":
    "ఇతర బ్యూరో పురుష ప్రొఫైల్స్‌ను అన్వేషించండి",
  "dashboard.buttons.exploreOtherFemale":
    "ఇతర బ్యూరో మహిళా ప్రొఫైల్స్‌ను అన్వేషించండి",
  "dashboard.buttons.viewAllShortlisted": "ఎంపిక చేసిన ప్రొఫైల్స్ అన్నీ చూడండి",
  "dashboard.buttons.viewAllFree": "ఫ్రీ ప్రొఫైల్స్ అన్నీ చూడండి",
  "dashboard.buttons.viewAllPaid": "పెయిడ్ ప్రొఫైల్స్ అన్నీ చూడండి",
  "dashboard.buttons.viewAllRedzone": "రెడ్ జోన్ ప్రొఫైల్స్ అన్నీ చూడండి",
  "dashboard.buttons.viewAllCallBack":
    "కాల్ బ్యాక్ ప్రొఫైల్స్ అన్నీ చూడండి",
  "dashboard.buttons.viewAllNotResponding":
    "స్పందించని ప్రొఫైల్స్ అన్నీ చూడండి",
  "dashboard.buttons.viewAllOtherMediator": "ఇతర మిడియేటర్ ప్రొఫైల్స్ అన్నీ చూడండి",
  "searchById.title": "ఐడి ద్వారా వెతకండి",
  "searchById.fields.martialId": "మార్షల్ ఐడి",
  "searchById.fields.martialIdPlaceholder": "మార్షల్ ఐడి నమోదు చేయండి",
  "searchById.actions.search": "వెతకండి",
  "searchById.errors.requiredMartialId": "దయచేసి మార్షల్ ఐడి నమోదు చేయండి.",
  "bottomNav.home": "హోమ్",
  "bottomNav.search": "వెతకండి",
  "bottomNav.addProfile": "ప్రొఫైల్ జోడించు",
  "bottomNav.shareUrl": "లింక్ పంచుకోండి",
  "bottomNav.myWeb": "నా వెబ్",
  "bottomNav.modal.title": "ప్రొఫైల్ జోడించు",
  "bottomNav.modal.description": "ప్రొఫైల్ సృష్టించే విధానాన్ని ఎంచుకోండి:",
  "bottomNav.modal.own": "మీ స్వంత ప్రొఫైల్ జోడించండి",
  "bottomNav.modal.mediator": "మిడియేటర్ ప్రొఫైల్ జోడించండి",
  "bottomNav.modal.addViaText": "టెక్స్టుతో జోడించు",
  "bottomNav.modal.addViaImage": "చిత్రంతో జోడించు",
  "bottomNav.modal.addBasic": "ప్రాథమిక వివరాలు జోడించు",
  "bottomNav.modal.addManually": "మాన్యువల్‌గా జోడించు",
  "bottomNav.modal.addFullRecommended": "పూర్తి వివరాలు జోడించు (సిఫార్సు చేయబడింది)",
  "bottomNav.modal.cancel": "రద్దు",
  callBack: "కాల్ బ్యాక్",
  notResponding: "స్పందించడం లేదు",
  "Call Back Profiles": "కాల్ బ్యాక్ ప్రొఫైల్స్",
  "Not Responding Profiles": "స్పందించని ప్రొఫైల్స్",
  "Move to Call Back": "కాల్ బ్యాక్‌కు మార్చు",
  "Move to Not Responding": "స్పందించడం లేదు కి మార్చు",
  "Follow up": "ఫాలో అప్",
  "alerts.suspended.accountTitle": "మీ వ్యాపార ఖాతా సస్పెండ్ చేయబడింది.",
  "alerts.suspended.accountDescription": "దయచేసి కస్టమర్ కేర్‌ను సంప్రదించండి.",
  "alerts.suspended.websiteTitle":
    "ఈ వెబ్‌సైట్ సస్పెండ్ చేయబడింది",
  "alerts.suspended.websiteDescription":
    "దయచేసి అన్ని వినియోగదారులను హెచ్చరించండి.",
  "matches.filters.all": "అన్ని",
  "matches.labels.score": "స్కోరు",
  "matches.labels.public": "పబ్లిక్",
  "matches.labels.views": "వీక్షణలు",
  "matches.laebels.private": "ప్రైవేట్",
  "matches.labels.viewsCount": "{count} వీక్షణలు",
  "matches.labels.lastSeen": "చివరిసారి చూసినది",
  "matches.labels.createdBy": "సృష్టికర్త",
  "matches.labels.by": "ద్వారా",
  "matches.buttons.viewProfile": "ప్రొఫైల్ చూడండి",
  "matches.buttons.view": "చూడండి",
  "matches.buttons.switch": "మార్చు",
  "matches.buttons.manage": "నిర్వహించు",
  "matches.buttons.manageProfile": "ప్రొఫైల్ నిర్వహించు",
  "matches.buttons.share": "పంచుకోండి",
  "matches.buttons.report": "ఫిర్యాదు",
  "matches.buttons.retry": "మళ్లీ ప్రయత్నించండి",
  "matches.buttons.refresh": "రిఫ్రెష్",
  "matches.messages.empty":
    "ప్రస్తుతం మ్యాచ్‌లు లేవు. దయచేసి ఫిల్టర్లను మార్చండి లేదా కొంతసేపటి తర్వాత ప్రయత్నించండి.",
  "matches.messages.loading": "మరిన్ని మ్యాచ్‌లను లోడ్ చేస్తున్నాం…",
  "matches.messages.end": "జాబితా ముగిసింది.",
  "matches.count.withTotal":
    "మొత్తం {total} మ్యాచ్‌లలో {visible} చూపిస్తున్నాం",
  "matches.count.noTotal": "{visible} మ్యాచ్‌లు దొరికాయి",
  "Your customer website is pending.":
    "మీ కస్టమర్ వెబ్‌సైట్ ఇంకా పూర్తికాలేదు.",
  "Preview Website": "వెబ్‌సైట్ చూడండి",
  "Your customer leads": "మీ కస్టమర్ లీడ్స్",
  Calls: "కాల్స్",
  WhatsApp: "వాట్సాప్",

  "Complete Your Website Setup": "మీ వెబ్‌సైట్ సెటప్‌ను పూర్తి చేయండి",
  Completed: "పూర్తయ్యింది",
  Pending: "పెండింగ్‌లో ఉంది",

  "Failed to load dashboard data.": "డ్యాష్‌బోర్డ్ డేటాను లోడ్ చేయలేకపోయాము.",
  "Unable to load dashboard data. Please try again shortly.":
    "డ్యాష్‌బోర్డ్ డేటాను లోడ్ చేయడం సాధ్యపడలేదు. దయచేసి కొద్దిసేపటికి మళ్లీ ప్రయత్నించండి.",

  "Loading brand value metrics...": "బ్రాండ్ విలువ వివరాలు లోడ్ అవుతున్నాయి...",
  "Your Business Score": "మీ వ్యాపార స్కోర్",

  "Complete Profiles:": "పూర్తి చేసిన ప్రొఫైల్స్:",
  profile: "ప్రొఫైల్",
  profiles: "ప్రొఫైల్స్",
  "crossed 80% data completeness": "80% డేటా పూర్తి స్థాయిని దాటాయి",

  "No profiles have crossed 80% data completeness yet.":
    "ఇప్పటివరకు ఏ ప్రొఫైల్ కూడా 80% డేటా పూర్తి స్థాయిని దాటలేదు.",

  "Each 80% complete profile adds +0.1% to your brand value.":
    "80% డేటా పూర్తైన ప్రతి ప్రొఫైల్ మీ బ్రాండ్ విలువకు +0.1% ను జోడిస్తుంది.",

  "Complete your first profile to start growing your brand value.":
    "మీ బ్రాండ్ విలువ పెరగడానికి మీ మొదటి ప్రొఫైల్‌ను పూర్తి చేయండి.",

  "Based on {{count}} profile with completeness data.":
    "{{count}} డేటా పూర్తైన ప్రొఫైల్ ఆధారంగా.",

  "Based on {{count}} profiles with completeness data.":
    "{{count}} డేటా పూర్తైన ప్రొఫైల్స్ ఆధారంగా.",

  "Your Profiles": "మీ ప్రొఫైల్స్",
  "Pending Profiles": "పెండింగ్ ప్రొఫైల్స్",
  "Other Profiles": "ఇతర ప్రొఫైల్స్",
  "Other Bureau": "ఇతర బ్యూరో",

  Male: "వరుడు",
  Female: "వధువు",
  Shortlisted: "షార్ట్‌లిస్ట్ చేసినవి",

  yrs: "సంవత్సరాలు",
  "Match Score:": "మ్యాచ్ స్కోర్:",

  "No profiles found.": "ప్రొఫైల్స్ కనబడలేదు.",

  "View All": "అన్నీ చూడండి",
  "Review Pending": "పెండింగ్‌ను పరిశీలించండి",
  Explore: "వీక్షించండి",
  "View All Shortlisted": "షార్ట్‌లిస్ట్ అన్నీ చూడండి",
  "Add Website Details": "వెబ్‌సైట్ వివరాలను జోడించు",
  "Update your business name, tagline, and about section.":
    "మీ వ్యాపార పేరు, ట్యాగ్లైన్ మరియు వివరాలను నవీకరించడం",
  "Add Social Links": "సోషల్ లింక్‌లను జోడించు",
  "Update your social media links for your website footer.":
    "మీ వెబ్‌సైట్ ఫుటర్‌లో మీ సోషల్ మీడియా లింక్‌లను నవీకరించడం",
  "Add Business Video Links": "వ్యాపార వీడిఓ లింక్‌లను జోడించు",
  "Add YouTube or business video links to your website.":
    "మీ వెబ్‌సైట్‌కు YouTube లేదా వ్యాపార వీడియో లింక్‌లను జోడించండి.",
  "Add Slider Banners": "స్లైడర్ బ్యానర్లను జోడించండి",
  "Upload at least 3 banner images for your homepage slider.":
    "మీ హోమ్‌పేజ్ స్లైడర్ కోసం కనీసం 3 బ్యానర్ చిత్రాలను అప్‌లోడ్ చేయండి.",
  "Add Terms & Conditions": "నియమాలు & షరతులు జోడించండి",
  "Publish your terms and conditions for transparency.":
    "పారదర్శకత కోసం మీ నియమాలు మరియు షరతులను ప్రచురించండి.",
  "Add Success Stories": "విజయ గాథలను జోడించండి",
  "Add customer success stories to build trust.":
    "నమ్మకం పెంచేందుకు కస్టమర్ విజయ గాథలను జోడించండి.",
  "Add Testimonials": "అభిప్రాయాలను జోడించండి",
  "Add client testimonials to enhance credibility.":
    "నమ్మకత్వాన్ని పెంచేందుకు కస్టమర్ అభిప్రాయాలను జోడించండి.",
  "Add Services": "సేవలను జోడించండి",
  "List the services offered by your bureau.":
    "మీ బ్యూరో అందిస్తున్న సేవల జాబితాను ఇవ్వండి.",

  shortlist: "షార్ట్‌లిస్ట్",
  Edit: "సవరించు",
  profile_score: "స్కోర్",
  views: "వీక్షణలు",
  public: "పబ్లిక్",
  private: "ప్రైవేట్",
  personal_information: "వ్యక్తిగత సమాచారం",
  date_of_birth: "పుట్టిన తేదీ",
  age: "వయస్సు",
  birth_place: "పుట్టిన ప్రదేశం",
  birth_time: "పుట్టిన సమయం",
  height: "ఎత్తు",
  weight: "బరువు",
  body_type: "శరీర రకం",
  languages_known: "తెలిసిన భాషలు",
  marital_status: "వైవాహిక స్థితి",
  lives_in: "నివసిస్తున్న ప్రదేశం",

  habits: "అలవాట్లు",
  eating_habits: "తినే అలవాట్లు",
  "Eating Habits": "తినే అలవాట్లు",
  smoking_habits: "ధూమపాన అలవాట్లు",
  "Smoking Habits": "ధూమపాన అలవాట్లు",
  drinking_habits: "మద్యపాన అలవాట్లు",
  "Drinking Habits": "మద్యపాన అలవాట్లు",

  religion_caste_details: "మతం & కులం వివరాలు",
  religion: "మతం",
  mother_tongue: "మాతృభాష",
  caste: "కులం",
  sub_caste: "ఉపకులం",
  gothram: "గోత్రం",
  dosham: "దోషం",
  UncleGothram: "మామ గోత్రం",

  horoscope_information: "జాతక సమాచారం",
  star: "నక్షత్రం",
  rashi: "రాశి",

  professional_details: "వృత్తి వివరాలు",
  education: "విద్య",
  Education: "విద్య",
  employment: "ఉపాధి స్థితి",
  occupation: "వృత్తి",
  income: "వార్షిక ఆదాయం",
  "Anuual Income": "వార్షిక ఆదాయం",
  job_location: "ఉద్యోగ ప్రదేశం",
  "Job Location": "ఉద్యోగ ప్రదేశం",

  family_details: "కుటుంబ వివరాలు",
  father_employee: "తండ్రి ఉద్యోగి",
  father_occupation: "తండ్రి వృత్తి",
  mother_employee: "తల్లి ఉద్యోగి",
  mother_occupation: "తల్లి వృత్తి",
  family_type: "కుటుంబ రకం",
  family_value: "కుటుంబ విలువ",
  total_brothers: "మొత్తం సోదరులు",
  elder_brothers: "అన్నలు",
  younger_brothers: "తమ్ములు",
  total_sisters: "మొత్తం సోదరీమణులు",
  elder_sisters: "అక్కలు",
  younger_sisters: "చెల్లెళ్లు",
  native_place: "స్వదేశం",

  property_details: "ఆస్తి వివరాలు",
  house_type: "ఇల్లు రకం",
  number_of_houses: "ఇళ్ల సంఖ్య",
  house_sq_feet: "ఇల్లు చ.అడుగులు",
  house_value: "ఇల్లు విలువ",
  house_location: "ఇల్లు ప్రదేశం",
  commercial_property: "వాణిజ్య ఆస్తి",
  commercialSqYards: "వాణిజ్య స్థలాలు చ.గజాలు",
  monthly_rent: "నెలవారీ అద్దె",
  open_plots: "ఖాళీ స్థలాలు",
  open_plots_sq_yards: "ఖాళీ స్థలాలు చ.గజాలు",
  open_plots_value: "ఖాళీ స్థలాల విలువ",
  agriculture_land: "వ్యవసాయ భూమి",
  agriculture_land_value: "వ్యవసాయ భూమి విలువ",
  total_property_value: "మొత్తం ఆస్తి విలువ",
  plotLocation: "స్థల ప్రదేశం",
  contact_information: "సంప్రదింపు సమాచారం",
  about_myself: "నా గురించి",
  extra_talented_skills: "అదనపు నైపుణ్యాలు",
  partner_preference: "భాగస్వామి ప్రాధాన్యతలు",
  flatType: "ఫ్లాట్ రకం",
  flatValue: "ఫ్లాట్ విలువ",

  // Report Modal
  "report.title": "ప్రొఫైల్‌ను రిపోర్ట్ చేయండి",
  "report.reportingProfile": "రిపోర్టింగ్ ప్రొఫైల్:",
  "report.maritalId": "వైవాహిక ID:",
  "report.reasonLabel": "రిపోర్ట్ చేయడానికి కారణం *",
  "report.reasonPlaceholder": "కారణాన్ని ఎంచుకోండి...",
  "report.detailsLabel": "అదనపు వివరాలు (ఐచ్ఛికం)",
  "report.detailsPlaceholder":
    "దయచేసి మీ రిపోర్ట్ గురించి మరిన్ని వివరాలు అందించండి...",
  "report.submitting": "రిపోర్ట్ చేస్తున్నాం...",
  "report.submit": "రిపోర్ట్ సబ్మిట్ చేయండి",

  // Contact Section
  "contact.upgradeMessage":
    "సంప్రదింపు సమాచారాన్ని చూడటానికి అప్‌గ్రేడ్ చేయండి.",
  "contact.viewDetails": "సంప్రదింపు వివరాలను చూడండి →",
  "contact.protectedBy": "ఈ ప్రొఫైల్‌ను రక్షిస్తున్నది",
  "contact.marriageBureau": "వివాహ బ్యూరో",
  "contact.ownerName": "యజమాని పేరు:",
  "contact.bureauAddress": "బ్యూరో చిరునామా:",
  "contact.contact": "సంప్రదింపు:",
  "contact.call": "కాల్ చేయండి",
  "contact.whatsapp": "వాట్సాప్",
  "contact.mobileNumber": "మొబైల్ నంబర్:",

  // Partner Preferences Sections
  "preferences.basic": "ప్రాథమిక ప్రాధాన్యతలు",
  "preferences.religious": "మత ప్రాధాన్యతలు",
  "preferences.property": "ఆస్తి ప్రాధాన్యతలు",
  "preferences.professional": "వృత్తి ప్రాధాన్యతలు",
  "preferences.location": "ప్రదేశ ప్రాధాన్యతలు",
  "preferences.horoscope": "జాతక ప్రాధాన్యతలు",
  "preferences.habits": "అలవాట్ల ప్రాధాన్యతలు",

  "preferences.preferredAge": "ఇష్టపడే వయస్సు",
  "preferences.preferredHeight": "ఇష్టపడే ఎత్తు",
  "preferences.preferredMaritalStatus": "ఇష్టపడే వైవాహిక స్థితి",
  "preferences.physicalStatus": "శారీరక స్థితి",
  "preferences.eatingHabits": "తినే అలవాట్లు",
  "preferences.drinkingHabits": "మద్యపాన అలవాట్లు",
  "preferences.smokingHabits": "ధూమపాన అలవాట్లు",
  "preferences.preferredReligion": "ఇష్టపడే మతం",
  "preferences.preferredMotherTongue": "ఇష్టపడే మాతృభాష",
  "preferences.preferredCaste": "ఇష్టపడే కులం",
  "preferences.preferredSubcaste": "ఇష్టపడే ఉపకులం",
  "preferences.preferredHouseType": "ఇష్టపడే ఇల్లు రకం",
  "preferences.preferredHouseSqYards": "ఇష్టపడే ఇల్లు చ.గజాలు",
  "preferences.preferredMonthlyRent": "ఇష్టపడే నెలవారీ అద్దె",
  "preferences.preferredOpenPlot": "ఇష్టపడే ఖాళీ స్థలం",
  "preferences.preferredFlat": "ఇష్టపడే ఫ్లాట్",
  "preferences.preferredOwnLocation": "ఇష్టపడే స్వంత ప్రదేశం",
  "preferences.preferredAgriculturalLand": "ఇష్టపడే వ్యవసాయ భూమి",
  "preferences.totalPropertyValue": "మొత్తం ఆస్తి విలువ",
  "preferences.preferredEducation": "ఇష్టపడే విద్య",
  "preferences.preferredEmployment": "ఇష్టపడే ఉపాధి",
  "preferences.preferredOccupation": "ఇష్టపడే వృత్తి",
  "preferences.preferredAnnualIncome": "ఇష్టపడే వార్షిక ఆదాయం",
  "preferences.preferredFamily": "ఇష్టపడే కుటుంబం",
  "preferences.preferredSettledLocation": "ఇష్టపడే స్థిరపడిన ప్రదేశం",
  "preferences.preferredCountry": "ఇష్టపడే దేశం",
  "preferences.preferredState": "ఇష్టపడే రాష్ట్రం",
  "preferences.preferredCity": "ఇష్టపడే నగరం",
  "preferences.preferredCitizenship": "ఇష్టపడే పౌరసత్వం",
  "preferences.preferredStar": "ఇష్టపడే నక్షత్రం",
  "preferences.preferredRashi": "ఇష్టపడే రాశి",
  "preferences.preferredDosham": "ఇష్టపడే దోషం",
  "Create Profile": "ప్రొఫైల్ సృష్టించండి",
  Upgrade: "ఉప్గ్రేడ్",
  "Paid Account": "పెయిడ్ ఖాతా",
  "Free Account": "ఫ్రీ ఖాతా",
  active: "క్రియాశీల",
  inactive: "నిష్క్రియ",
  paid: "చెల్లించిన",
  free: "ఉచిత",
  onlyOnline: "ఆన్‌లైన్ మాత్రమే",
  onlyOffline: "ఆఫ్‌లైన్ మాత్రమే",
  onlineOffline: "ఆన్‌లైన్ ఆఫ్‌లైన్",
  createdBySuperAdmin: "సూపర్ అడ్మిన్ ద్వారా సృష్టించబడింది",
  createdAt: "సృష్టించిన తేదీ:",

  //new
  religionCaste: "మతం & కులం",
  step: "దశ",
  stepOf: "దశ",
  progress: "పురోగతి",
  "Profile Creation Steps": "ప్రొఫైల్ సృష్టి దశలు",
  "Basic Info": "ప్రాథమిక సమాచారం",
  "Education Details": "విద్య వివరాలు",
  "Family Details": "కుటుంబ వివరాలు",
  "Property Details": "ఆస్తి వివరాలు",
  "Agriculture & Flat Details": "వ్యవసాయం & ఫ్లాట్ వివరాలు",
  "Location Details": "స్థానం వివరాలు",
  "Partner Preferences": "భాగస్వామి ప్రాధాన్యతలు",
  photosDocuments: "ఫోటోలు & పత్రాలు",
  of: "యొక్క",
  "Full Name": "పూర్తి పేరు",
  Password: "పాస్‌వర్డ్",
  "Contact Number": "సంప్రదింపు నంబర్",
  "Mediator Contact Number": "మధ్యవర్తి సంప్రదింపు నంబర్",
  "step1.selectGender": "లింగాన్ని ఎంచుకోండి",
  "step1.self": "స్వయం",
  "step1.indianProfile": "భారతీయ ప్రొఫైల్",
  "step1.gender": "లింగం",
  "step1.createdBy": "సృష్టికర్త",
  "Click the icon to upload your photo":
    "మీ ఫోటోను అప్‌లోడ్ చేయడానికి ఐకాన్‌పై క్లిక్ చేయండి",
  male_kids: "మగ పిల్లలు",
  female_kids: "ఆడ పిల్లలు",
  select: "ఎంచుకోండి",

  are_children_with_you: "పుట్టిన పిల్లలు మీతో ఉన్నారా?",
  Back: "వెనక్కి",
  Add: "చేర్చండి",
  Mediator: "మధ్యవర్తి",
  Own: "స్వంత",
  "Profile via Text": "టెక్స్ట్ ద్వారా ప్రొఫైల్",
  "Paste Profile Details": "ప్రొఫైల్ వివరాలను పేస్ట్ చేయండి",
  Processing: "ప్రాసెస్ చేస్తున్నాం",
  "Parse & Extract Data": "డేటాను పార్స్ & ఎక్స్‌ట్రాక్ట్ చేయండి",
  "Saving profile, please wait":
    "ప్రొఫైల్‌ను సేవ్ చేస్తున్నాం, దయచేసి వేచి ఉండండి",
  Gender: "లింగం",
  "Created By": "సృష్టికర్త",
  "Profile Status": "ప్రొఫైల్ స్థితి",
  Citizenship: "పౌరసత్వం",
  "Enter Mediator Contact Details":
    "మధ్యవర్తి సంప్రదింపు వివరాలను నమోదు చేయండి",
  "Enter Customer Contact Details": "కస్టమర్ సంప్రదింపు వివరాలను నమోదు చేయండి",
  "Auto-generated": "ఆటో-జనరేటెడ్",
  "Date of Birth": "పుట్టిన తేదీ",
  "Total Property Value": "మొత్తం ఆస్తి విలువ",
  "Place of Birth": "పుట్టిన ప్రదేశం",
  Country: "దేశం",
  State: "రాష్ట్రం",
  District: "జిల్లా",
  City: "నగరం",
  "Profile Description/Preference": "ప్రొఫైల్ వివరణ/ప్రాధాన్యత",
  Cancel: "రద్దు",
  "Select Gender": "లింగం ఎంచుకోండి",
  "Birth Time": "పుట్టిన సమయం",
  "Marital Status": "వైవాహిక స్థితి",
  Qualification: "అర్హత",
  "Employment Status": "ఉద్యోగ స్థితి",
  "Married Brothers": "వివాహిత సోదరులు",
  "Married Sisters": "వివాహిత సోదరీమణులు",
  "Physical State": "శారీరక స్థితి",
  "Any Other Bussiness": "ఇతర వ్యాపారం ఏదైనా",
  "Other Business Income": "ఇతర వ్యాపార ఆదాయం",
  Business_Location: "వ్యాపార ప్రదేశం",
  extraSkills: "అదనపు నైపుణ్యాలు",
  "Father Employee": "తండ్రి ఉద్యోగి",
  "Mother Employee": "తల్లి ఉద్యోగి",
  "Father Occupation": "తండ్రి వృత్తి",
  "Mother Occupation": "తల్లి వృత్తి",
  "Family Status": "కుటుంబ స్థితి",
  number_of_younger_brothers: "తమ్ముళ్ల సంఖ్య",
  number_of_elder_brothers: "అన్నల సంఖ్య",
  number_of_younger_sisters: "చెల్లెళ్ల సంఖ్య",
  number_of_elder_sisters: "అక్కల సంఖ్య",
  "Proper Location": "సరైన ప్రదేశం",
  "Setteled Location": "స్థిరపడిన ప్రదేశం",
  "House Type": "ఇల్లు రకం",
  "No Of Houses": "ఇళ్ల సంఖ్య",
  "Own House sq Yard": "స్వంత ఇల్లు చ.గజాలు",
  "Own House Total Value": "స్వంత ఇల్లు మొత్తం విలువ",
  "Commercial Shops": "వాణిజ్య దుకాణాలు",
  "Shops Sq Yards": "దుకాణాలు చ.గజాలు",
  "Monthly Rent": "నెలవారీ అద్దె",
  "Open Plots": "ఖాళీ స్థలాలు",
  "Open Plots Sq Yards": "ఖాళీ స్థలాలు చ.గజాలు",
  "Open Plots total value": "ఖాళీ స్థలాల మొత్తం విలువ",
  "Own House Location": "స్వంత ఇల్లు ప్రదేశం",
  "Plot Location": "స్థలం ప్రదేశం",
  "Number Of Apartment Flats": "అపార్ట్‌మెంట్ ఫ్లాట్స్ సంఖ్య",
  "Flat Type": "ఫ్లాట్ రకం",
  "Flat Value": "ఫ్లాట్ విలువ",
  "Agriculture Land": "వ్యవసాయ భూమి",
  "Agriculture Land Value": "వ్యవసాయ భూమి విలువ",
  "Total Properties Value": "మొత్తం ఆస్తుల విలువ",
  "Anymore Properties": "ఇంకా ఆస్తులు ఏమైనా",
  "Flat Location": "ఫ్లాట్ ప్రదేశం",
  "Agriculture Land Location": "వ్యవసాయ భూమి ప్రదేశం",
  "Caste & Religion Preferences": "కులం & మతం ప్రాధాన్యతలు",
  "Religion Preferences": "మతం ప్రాధాన్యతలు",
  "Caste Preferences": "కులం ప్రాధాన్యతలు",
  "Sub Caste Preferences": "ఉపకులం ప్రాధాన్యతలు",
  "Mother Toungue Preferences": "మాతృభాష ప్రాధాన్యతలు",
  "Marital Status Preferences": "వైవాహిక స్థితి ప్రాధాన్యతలు",
  "children PreferenceOptions": "పిల్లల ప్రాధాన్యతలు",
  "Age Preferences": "వయస్సు ప్రాధాన్యతలు",
  "Height Preferences": "ఎత్తు ప్రాధాన్యతలు",
  "Created by preference": "సృష్టికర్త ప్రాధాన్యతలు",
  "Horoscope Preferences": "జాతక ప్రాధాన్యతలు",
  "Star Preference": "నక్షత్ర ప్రాధాన్యత",
  "Rashi Preference": "రాశి ప్రాధాన్యత",
  "Dosham Preference": "దోషం ప్రాధాన్యత",
  "Hobbies Preferences": "హాబీలు ప్రాధాన్యతలు",
  "Eating Preference": "తినే ప్రాధాన్యతలు",
  "Drinking Preference": "మద్యపాన ప్రాధాన్యతలు",
  "Smoking Preference": "ధూమపాన ప్రాధాన్యతలు",
  "Education & Job Preferences": "విద్య & ఉద్యోగ ప్రాధాన్యతలు",
  "Education Preferences": "విద్య ప్రాధాన్యతలు",
  "Occupation Preference": "వృత్తి ప్రాధాన్యత",
  "Job Location Preference": "ఉద్యోగ ప్రదేశం ప్రాధాన్యత",
  "Anuual Income Preference": "వార్షిక ఆదాయం ప్రాధాన్యత",
  "Partner Family Preference": "భాగస్వామి కుటుంబ ప్రాధాన్యతలు",
  "Setelled Location Preference": "స్థిరపడిన ప్రదేశం ప్రాధాన్యత",
  "House Type Preference": "ఇల్లు రకం ప్రాధాన్యత",
  "Own House sq Yard Preference": "స్వంత ఇల్లు చ.గజాలు ప్రాధాన్యత",
  "Monthly Rent Preference": "నెలవారీ అద్దె ప్రాధాన్యత",
  "Open Plots Preference": "ఖాళీ స్థలాలు ప్రాధాన్యత",
  "Flat Type Preference": "ఫ్లాట్ రకం ప్రాధాన్యత",
  "Apartment Flats Preference": "అపార్ట్‌మెంట్ ఫ్లాట్స్ ప్రాధాన్యత",
  "Own Location Preference": "స్వంత ప్రదేశం ప్రాధాన్యత",
  "Agriculture Land Preference": "వ్యవసాయ భూమి ప్రాధాన్యత",
  "Total Property Value Preference": "మొత్తం ఆస్తి విలువ ప్రాధాన్యత",
  "Property Preferences": "ఆస్తి ప్రాధాన్యతలు",
  "Location Preferences": "ప్రదేశ ప్రాధాన్యతలు",
  "Country Preference": "దేశ ప్రాధాన్యత",
  "State Preference": "రాష్ట్రం ప్రాధాన్యత",
  "City Preference": "నగరం ప్రాధాన్యత",
  "Citizenship Preference": "పౌరసత్వం ప్రాధాన్యత",
  Submit: "సబ్మిట్ చేయండి",
  "contact.details.warning":
    "మీరు ఇంకా 50 ప్రొఫైల్ యాడ్ చేయడం కంప్లీట్ చేయలేదు కావున మీకు ఇతర బ్యూరో కాంటాక్ట్ డీటెయిల్స్ చూపించలేము.",
  "Download Biodata": "బయోడేటా డౌన్‌లోడ్ చేయండి",
  "Contact Details": "సంప్రదింపు వివరాలు",
  skip: "వదిలేయండి",
  "birth time": "జనన సమయం",
  "Share your website": "మీ వెబ్‌సైట్‌ను షేర్ చేయండి",
  "Preview your website": "మీ వెబ్‌సైట్‌ను ప్రివ్యూ చేయండి",
};

export default teTranslations;
